<template>
  <div>
    <main id="page_sub">
      <section id="page_contents">
        <h5>공지사항</h5>
        <!---검색영역/kendo-ui form활용 --->
        <div class="sf_box">
          <p>
            <kendo-maskedtextbox
                    ref="titleRef"
                    id="title"
                    class="userInput"
                    :style="'width: 293px; height: 39px; '"
                    :placeholder="'검색어를 입력하세요'"
                    @change="commonOnChangeEvent"
            >
            </kendo-maskedtextbox>
          </p>
          <p :onclick="commonOnChangeEvent" style="background: #fe5f40;width:38px;height:38px;border-radius:5px;text-align:center;line-height:35px; cursor: pointer;">
            <span style="color:#fff;">
              <span class="k-icon k-i-zoom"></span>
            </span>
          </p>
        </div>
        <div class="clear"></div>
        <!---//검색영역/kendo-ui form활용 --->
        <div id="notice">
          <!-- Kendo-grid 영역 시작 -->
          <kendo-grid ref="noticeListGridRef"
                      :style="'width: 100%; height: 100%; cursor:pointer;  '"
                      :data-source="computedNoticeGridRows"
                      :scrollable="false"
                      :filterable="false"
                      :selectable="'row'"
                      :pageable-always-visible="true"
                      :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                      :columns="noticeListColumns"
                      @change="onRowClick"
          >
          </kendo-grid>
        </div>
        <div class="tcenter mt20"></div>
        <div class="tright" v-if="isAdminUser === true">
          <!--<kendo-button class="k-button" @click="deleteNotice">삭제하기</kendo-button>-->
          <kendo-button class="k-button k-primary" @click="writeNotice">등록하기</kendo-button>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import ApiConfig from '../../api/api.config'
  import EtnersKendoGridUtil from '../../common/kendo.grid.util'

  const platformDomain = ApiConfig.platformDomain

  export default {
    created : function () {

    },
    mounted () {
      let params = {
        loginUserToken: sessionStorage.getItem('lutk'),
        skip          : this.skip,
        take          : this.take,
        page          : (this.skip + 10) / 10,
        pageSize      : this.take,
        requestType   : 'PAGING', // PAGING or EXPORT
      }
      this.$store.dispatch('FETCH_NOTICE_LIST', params).then(data => {

        this.dataItems = data.resultData
        this.totaldata = data.total
      })

      const refs = this.$refs
      const doc = document

      setTimeout(function () {
        /*****************************************
         * 검색조건 엔터키 이벤트 적용 부분
         *****************************************/

          //검색조건 엔터키 이벤트 적용
        const enterkeyEventTargetIdArray = 'title'

        let targetId = enterkeyEventTargetIdArray

        let element = doc.getElementById(targetId)

        if (element != undefined) {
          element.onkeyup = function () {
            const ENTER_KEY_CODE = 13

            let currentKeyCode = window.event.keyCode

            if (currentKeyCode == ENTER_KEY_CODE) {
              if (refs.noticeListGridRef != undefined) {
                let noticeListGridRef = refs.noticeListGridRef.kendoWidget()

                if (noticeListGridRef != undefined) {
                  const dataSource = refs.noticeListGridRef.kendoWidget().dataSource

                  if (dataSource != undefined) {
                    dataSource.read()
                  }
                }

              }
            }
          }
        }

      }, 300)

    },
    updated : function () {
    },
    computed: {
      computedNoticeGridRows: function () {
        //parameterMap 안에서의 this는 Vue가 아니므로 미리 vm 변수로 바인딩.
        const vm = this

        const store = this.$store

        const noticeListDataSource = new kendo.data.DataSource({
          name           : 'noticeList',
          page           : 1,
          pageSize       : 10,
          serverPaging   : true,
          serverFiltering: true,
          serverSorting  : true,
          transport      : {
            read        : {
              url        : `${platformDomain}/v1/ebmp/main/board/notice/list.json`,
              type       : 'POST',
              dataType   : 'json',
              contentType: 'application/json',
              cache      : false,
            },
            parameterMap: function (options, operation) {

              if (operation === 'read') {

                let paramToKendoFilters = vm.currentPageFilterOption()

                let integrationCustomFilters = paramToKendoFilters

                let params = {
                  loginUserToken: sessionStorage.getItem('lutk'),
                  skip          : options.skip,
                  take          : options.take,
                  page          : options.page,
                  pageSize      : options.pageSize,
                  filter        : integrationCustomFilters != undefined ? integrationCustomFilters : undefined,
                  sort          : options.sort,
                  requestType   : 'PAGING', //PAGING or EXPORT
                }

                store.dispatch('FETCH_NOTICE_LIST', params)

                return kendo.stringify(params)
              }

              if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) }
              }
            },
          },
          schema         : {
            type : 'json',
            parse: function (response) {
              // let solutionCodeMap = EtnersCommonUtil.getAllSolutionCodeMapUsingVuex()

              //맵이 초기화되었는지 여부 확인
              // const initSolutionCodeMapFl = solutionCodeMap != undefined

              // if (initSolutionCodeMapFl) {
              let changeResultData = response.resultData

              for (let i = 0; i < changeResultData.length; i++) {
                let row = changeResultData[i]
                // row.brdNo = i + 1

                if (row.brdGbn == '01') {
                  row.brdGbn = '일반공지'
                } else if (row.brdGbn == '02') {
                  row.brdGbn = '주요공지'
                } else if (row.brdGbn == '03') {
                  row.brdGbn = '긴급공지'
                }
              }

              response.resultData = changeResultData

              return response
            },
            total: function (response) {
              //console.log("response.total : " + response.total)
              return response.total
            },
            data : function (response) {
              if (response.resultStatus.messageCode == '2000') {
                return response.resultData
              } else {
                kendo.alert('message: ' + response.resultStatus.messageText)

                return ''
              }
            },
          },

          error: function (e) {
            console.log('error event handler', e.errors[0])
          },
        })

        return noticeListDataSource
      },
    },

    methods: {
      /**
       * 검색조건 생성
       */
      currentPageFilterOption: function () {
        let searchFilterOptions = new Array()

        const refs = this.$refs

        //검색어 검색
        if (refs.titleRef != undefined) {
          const title = refs.titleRef.kendoWidget().value()

          if (title != undefined && title != '') {
            searchFilterOptions.push(
              EtnersKendoGridUtil.generateFilterOption({ columnName: 'title', value: title }))
          }
        }

        return searchFilterOptions.length == 0 ? undefined : searchFilterOptions
      },

      onRowClick (ev) {

        let selectedRow = ev.sender.select()
        let item = ev.sender.dataItem(selectedRow)
        let brdNo = item.brdNo

        this.$router.push({ name: 'NoticeDetail', query: { brdNo: brdNo } })
      },
      writeNotice () {
        this.$router.push({ name: 'NoticeForm' })
      },
      commonOnChangeEvent: function (ev) {

        if (this.$refs.noticeListGridRef != undefined) {
          let noticeListGridRef = this.$refs.noticeListGridRef.kendoWidget()

          if (noticeListGridRef != undefined) {
            const dataSource = this.$refs.noticeListGridRef.kendoWidget().dataSource

            if (dataSource != undefined) {
              dataSource.page(1)
              dataSource.read()
            }
          }
        }

      },
    },
    data () {
      let loginUserData = JSON.parse(sessionStorage.getItem('loginUserData'))
      let isAdminUser = false

      if (loginUserData.authCd === '99999') {
        isAdminUser = true
      }

      return {
        isAdminUser      : isAdminUser,
        selectedField    : 'selected',
        selectedID       : 1,
        dataItems        : [],
        skip             : 0,
        take             : 10,
        totaldata        : 0,
        noticeFilter     : '',
        noticeListColumns: [
          { field: 'brdNo', title: '번호', width: '60px' },
          { field: 'brdGbn', title: '구분', width: '100px' },
          {
            field: 'title', title: '제목', width: '523px', attributes: { 'class': 'tleft' },
          },
          { field: 'userId', title: '작성자', width: '85px' },
          { field: 'rgstDt', title: '등록', width: '*' },
          { field: 'hitCnt', title: '조회수', width: '85px' },
        ],
      }
    },
  }
</script>

